import { ILevel } from '../../../../../../types/tasks.types'
import Dropdown from '../../../../../../shared/Inputs/Dropdown'
import { useRecoilValue } from 'recoil'
import sandboxAtom from '../../../../../Sandbox/sandbox.atom'
import { useMemo } from 'react'

interface IProps {
  level: ILevel['id']
  onChange: (level: ILevel['id'], name: string) => void
  name: string
}

const LevelDropdown = (props: IProps) => {
  const sandboxState = useRecoilValue(sandboxAtom)

  const options = useMemo(() => {
    return sandboxState.levels.map((l) => ({ title: l.name, value: l.id }))
  }, [sandboxState.levels])

  return (
    <Dropdown
      style={{ background: '#fff' }}
      options={options}
      selectedOption={props.level}
      title="Выберите уровень..."
      onSelect={props.onChange}
      name={props.name}
    />
  )
}

export default LevelDropdown
